import { watch } from 'vue'
import { useRoute } from '#app'
import { initGtm } from '@/utils/gtm'
import { whenOneTrustReady } from '@/utils/onetrust'

function isAuthoringContext(route: ReturnType<typeof useRoute>, pbBuilder: boolean) {
	return (
		pbBuilder ||
		Boolean(route.query['x-craft-live-preview'] || route.query['x-craft-preview'])
	)
}

export default defineNuxtPlugin(() => {
	const route = useRoute()
	const runtimeConfig = useRuntimeConfig()
	const deferredGtmContainerId = useState<string>('deferredGtmContainerId', () => '')

	if (isAuthoringContext(route, Boolean(runtimeConfig.public.pbBuilder))) {
		return
	}

	let consentReceived = false
	let initialized = false

	const resolveGtmId = () => {
		const configuredId = runtimeConfig.public.gtmId
		if (typeof configuredId === 'string' && configuredId.trim()) {
			return configuredId.trim().toUpperCase()
		}
		return deferredGtmContainerId.value || null
	}

	const tryInitGtm = () => {
		if (initialized || !consentReceived) return

		const gtmId = resolveGtmId()
		if (!gtmId) return

		initGtm(gtmId)
		initialized = true
	}

	whenOneTrustReady(() => {
		consentReceived = true
		tryInitGtm()
	})

	watch(deferredGtmContainerId, tryInitGtm)
})
